
import React from 'react';
import { useDispatch, useSelector  } from 'react-redux';

import { useReportProjectId } from '../../project';

import { getDefinition } from '../reducers';
import { getActions } from '../sagas';

export default function usePrintDefinition() {
    const dispatch = useDispatch();
    const printActions = getActions(dispatch);

    const printDefinition = useSelector(state => getDefinition(state.print));
    const reportProjectId = useReportProjectId();

    React.useEffect(() => {
        if (reportProjectId && !printDefinition.reportDefinition && !printDefinition.loading) {
            printActions.getDefinition(reportProjectId);
        }
    }, [reportProjectId]);

    return printDefinition;
}
